import React from "react";
import { Link, useNavigate } from "react-router-dom";

export default function BreadcrumbSection() {
  const navigate = useNavigate();
  return (
    <div className="sticky-header-next-sec  ec-breadcrumb section-space-mb">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="row ec_breadcrumb_inner product-bredcrumb">
              <div className="col-md-6 col-sm-6 col-6">
                <h2 className="ec-breadcrumb-title">
                  <span
                    title="Back"
                    className="mr-1"
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => navigate(-1)}
                  >
                    <i className="fa fa-chevron-left" />
                  </span>
                </h2>
              </div>
              <div className="col-md-6 col-sm-6 col-6">
                {/* ec-breadcrumb-list start */}
                <ul className="ec-breadcrumb-list">
                  <li className="ec-breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="ec-breadcrumb-item active">Products</li>
                </ul>
                {/* ec-breadcrumb-list end */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
